module.exports = __webpack_public_path__ + "img/home_1.d02b1fd7.svg";